import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import request from '@/utils/request';
//控件列表
export function controlList(data) {
  return request.post('admin/controls/list', data);
}
//修改控件状态
export function controlStatus(data) {
  return request.post('admin/controls/status', data);
}
//添加控件
export function addControl(data) {
  return request.post('admin/controls/store', data);
}
//控件详情
export function controlDetail(data) {
  return request.post('admin/controls/detail', data);
}
//编辑控件
export function editControl(data) {
  return request.post('admin/controls/edit', data);
}
//删除控件
export function delControl(data) {
  return request.post('admin/controls/delete', data);
}
//控件组列表
export function controlComponentsList(data) {
  return request.post('admin/components/list', data);
}
//添加控件组
export function addControlComponents(data) {
  return request.post('admin/components/store', data);
}
//控件组详情
export function controlComponentsDetail(data) {
  return request.post('admin/components/detail', data);
}
//删除控件组
export function delControlComponents(data) {
  return request.post('admin/components/delete', data);
}
//编辑控件组
export function editControlComponents(data) {
  return request.post('admin/components/edit', data);
}
//组件删除前的查询
export function delComponentsInfo(data) {
  return request.post('admin/components/delete/info', data);
}
//获取控件组件资源(配置页面需要)
export function getControlsResources(data) {
  return request.post('admin/dynamic-controls/get-controls', data).then(res => {
    res.map(item => {
      item.childer.map(item2 => {
        item2.controlsMark = item.mark;
      });
    });
    return res;
  });
}